import { Skeleton } from "@clarityos/ui";

export function PatientResultItemSkeleton() {
  return (
    <div className="flex w-full items-center gap-3 px-5 py-2">
      {/* Avatar */}
      <Skeleton shape="block" className="size-8 rounded-8" />

      <div className="flex flex-1 flex-col gap-px">
        <div className="flex h-5 items-center">
          <Skeleton className="h-3 w-36" />
        </div>
        <div className="flex h-4 items-center gap-2">
          <Skeleton className="h-2.5 w-16" />
          <Skeleton className="h-2.5 w-24" />
          <Skeleton className="h-2.5 w-20" />
        </div>
      </div>
      <Skeleton className="h-6.25 w-16" />
    </div>
  );
}
